import { MobileApp } from '../libs/proto/commUnity_pb';

export const communityAppType = MobileApp.VAC;

export const desktopMode = 1;
export const desktopModeURL = '';
